import { EntityReference, EntitySchema } from '@camberi/firecms';
import { CustomFilePreviewFunc } from '../App';

export interface Promotion {
  name: string;
  details: string; // Markdown.
  distributors: string; // Markdown.
  terms: string; // Markdown.
  whoQualifies: string; // Markdown.
  files: string[]; // File urls.
  image: string; // File urls.
  tags: string[];
  dateCreated: any;
  dateUpdated: any;
  visible: boolean;
  featured: boolean;
  isNew: boolean;
  relatedProducts: EntityReference[];
}

export default {
  name: 'Promotion',
  properties: {
    name: {
      title: 'Name',
      validation: { required: true },
      dataType: 'string',
    },
    relatedProducts: {
      dataType: 'array',
      title: 'Related Products',
      of: {
        dataType: 'reference',
        path: 'products',
      },
    },
    details: {
      title: 'Details',
      dataType: 'string',
      config: {
        markdown: true,
      },
    },
    distributors: {
      title: 'Distributors',
      dataType: 'string',
      config: {
        markdown: true,
      },
    },
    terms: {
      title: 'Terms',
      dataType: 'string',
      config: {
        markdown: true,
      },
    },
    whoQualifies: {
      title: 'Who Qualifies',
      dataType: 'string',
      config: {
        markdown: true,
      },
    },
    image: {
      title: 'Image',
      description: 'An optional picture to associate with the post.',
      dataType: 'string',
      config: {
        storageMeta: {
          mediaType: 'image',
          storagePath: 'dynamicImages',
          acceptedFiles: ['image/*'],
          fileName: (context) => {
            return context.file.name;
          },
        },
      },
    },
    files: {
      dataType: 'array',
      title: 'Files',
      description: 'The shareable files associated with this product (brochures, images, other marketing materials etc.)',

      of: {
        dataType: 'string',

        config: {
          Preview: CustomFilePreviewFunc,
          storageMeta: {
            storagePath: 'productFiles',
            fileName: (context: any) => {
              return context.file.name;
            },
          },
        },
      },
    },
    tags: {
      dataType: 'array',
      title: 'Tags',
      description: 'Used for categorization of the product',
      of: {
        dataType: 'string',
        config: {
          enumValues: {
            limitedTime: 'Limited Time',
            exclusive: 'Exclusive',
          },
        },
      },
    },
    visible: {
      title: 'Visible',
      dataType: 'boolean',
      description: 'Should this product be invisible?',
    },
    featured: {
      title: 'Featured',
      dataType: 'boolean',
      description: 'Should this product be featured on the dashboard?',
    },
    isNew: {
      title: 'Is New',
      dataType: 'boolean',
      description: 'Advertise this item with a "New!" tag?',
    },
    dateCreated: {
      title: 'Date Created',
      dataType: 'timestamp',
      autoValue: 'on_create',
      disabled: {
        hidden: true,
      },
    },
    dateUpdated: {
      title: 'Date Updated',
      dataType: 'timestamp',
      autoValue: 'on_update',
      disabled: {
        hidden: false,
      },
    },
  },
} as EntitySchema<Promotion>;
